import React, { useState } from "react";
import SubTabNav from "./common/SubTabNav";
import DateRangeField from "./DateRangeField";
import PresetChange from "./PresetChange";
import PresetValues from "./PresetValues";

interface PresetProps {
  machineId?: string;
  machineName?: string;
  machineData?: any;
}

const Preset: React.FC<PresetProps> = ({
  machineId,
  machineName,
  machineData,
}) => {
  const [activeTab, setActiveTab] = useState<
    "preset-change" | "preset-values" | "preset-compare"
  >("preset-change");

  const tabs = [
    { key: "preset-change", label: "Preset Change" },
    { key: "preset-values", label: "Preset Values" },
  ];

  const renderPresetChangeTab = () => (
    <PresetChange
      machineId={machineId}
      machineName={machineName}
      machineData={machineData}
    />
  );

  const renderPresetValuesTab = () => (
    <PresetValues machineId={machineId} machineData={machineData} />
  );

  // Preset comparison tab - reserved for future implementation
  // Will allow comparing different preset configurations and their performance outcomes

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "preset-change":
        return renderPresetChangeTab();
      case "preset-values":
        return renderPresetValuesTab();
      default:
        return renderPresetChangeTab();
    }
  };

  return (
    <div className="px-6 pb-6 pt-0">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <DateRangeField />
      </div>
      {/* Subtab Navigation */}
      <SubTabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) =>
          setActiveTab(tab as "preset-change" | "preset-values")
        }
      />

      {/* Tab Content */}
      {renderActiveTabContent()}
    </div>
  );
};

export default Preset;
